<!--
 * @Description: 
 * @Autor: txp
 * @Date: 2021-05-07 14:11:03
-->
<template>
    <div class="contentmain">
    <ThemePicker style="display:none"/>
      <div class="ft28 c333 mtb20">
        服务中心
      </div>
      <div class="flex justify_content_between">
        <LeftNav />
        <div class="rightcontent ml20">
          <!-- <keep-alive>
            <router-view  v-if="$route.meta.keepAlive"  />
          </keep-alive> -->
          <router-view />
        </div>
      </div>
  </div>
</template>
<script>
import LeftNav from '../components/leftnav/leftnav';

import ThemePicker from "../components/theme-picker/theme-picker"
export default {
  name: 'contentmain',
  components: {
    LeftNav,ThemePicker
    
  }
}
</script>
<style lang="scss">
  .contentmain{
    width: 1200px;
    max-width: 1200px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    .rightcontent{
      // flex: 1;
      width: 1020px;
    }
  }
</style>
